import SkeletonTable from "@/components/SkeletonTable";
import { useTahun } from "@/hooks/useTahun";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

const getListNominalUkt = async (tahun: number) => {
  const params = new URLSearchParams();
  if (tahun) params.set("tahun", tahun.toString());

  const response = await api.get("/master/nominal-ukt/index", {
    params: { tahun },
  });
  return response.data?.data;
};

export default function MasterNominalUktPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listNominalUkt", selectedTahun?.value],
    queryFn: () => getListNominalUkt(selectedTahun?.value || 0),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
